<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="pepCanceladoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Item <span class="badge badge-danger ml-2">Cancelado</span></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <pep-view-card 
                            v-else
                            :cancelado="true"
                            :side="true"
                            :marcacao="dados" 
                            :tamanho="'P'" 
                            :pode_atender="false" 
                            @abrir_doc_view="abrir_doc_view" />
                            
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import PepViewCard from './PepViewCard.vue';

export default {
    data () { 
        return { 
            dados: null, 
        }
    },

    components: { 
        AzEmptyState, 
        PepViewCard, 
    },

    methods: { 
        abrir_doc_view(doc) { 
            this.$emit('abrir_doc_view', doc);
        },

        abrir(atendimento, id_anamnese = null, id_laudo = null) { 
            this.dados = null;
            $("#pepCanceladoModal").modal('show');

            this.$util.load(this, { 
                service: "marcacoes",
                func: "index",
                parms: { 
                    id_paciente: atendimento.id_paciente, 
                    id_atendimento: atendimento.id_atendimento, 
                    id_anamnese: id_anamnese, 
                    id_laudo: id_laudo, 
                },
                loadTo: res => { 
                    let item = _.first(res);

                    _.set(item, 'item_status.ultima_etapa.id_etapa_atendimento', 7);
                    this.dados = item;
                }
            });
        }
    }
}
</script>